import React from 'react'

import {
  AlignItems,
  Box,
  Col,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Grid,
  JustifyContent,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

export type DiscountBox = {
  discount: string
  label: string
  bgColor: Color
  textColor: Color
}

const DEFAULT_BOXES: DiscountBox[] = [
  { discount: '50% OFF', label: '1st box', bgColor: Color.Primary_600, textColor: Color.White },
  { discount: '40% OFF', label: '2nd box', bgColor: Color.ColdGrey_500, textColor: Color.White },
  {
    discount: '20% OFF',
    label: '3rd-8th box',
    bgColor: Color.ColdGrey_500,
    textColor: Color.White,
  },
]

type DiscountPerWeekProps = {
  boxes?: DiscountBox[]
}

export const DiscountPerWeek = ({ boxes = DEFAULT_BOXES }: DiscountPerWeekProps) => {
  return (
    <Box data-testid="discount-per-week" display={Display.Flex}>
      <Grid columnGap={4} gridTemplateColumns={`repeat(${boxes.length}, 1fr)`}>
        {boxes.map((box) => (
          <Col key={box.label} size={1}>
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              flexDirection={FlexDirection.Column}
            >
              <Box
                bg={box.bgColor}
                borderRadius={1.5}
                width="90px"
                height="52px"
                display={Display.Flex}
                alignItems={AlignItems.Center}
                justifyContent={JustifyContent.Center}
                paddingH={[4, 2]}
              >
                <Text
                  size={5}
                  color={box.textColor}
                  fontWeight={FontWeight.Bold}
                  textAlign={TextAlign.Center}
                >
                  {box.discount}
                </Text>
              </Box>

              <Space size={2} />

              <Text
                size={2}
                color={box.textColor}
                textAlign={TextAlign.Center}
                style={{ whiteSpace: 'nowrap' }}
              >
                {box.label}
              </Text>
            </Box>
          </Col>
        ))}
      </Grid>
    </Box>
  )
}
